import React from 'react';
import AuthCard from '../../components/AuthCard';
import '../Auth/Auth.css';

const Login = () => {
  return (
    <div className="app auth-app">
      <AuthCard type="login" />
    </div>
  );
};

export default Login;
